import { getFormFields, getArrayValue } from '../form/form';

filterUpdate();

$(function(){
  // filter
  var filterEl = $('.realty-filter');

  // on select, input change => update filter
  filterEl.find('select, input').on('change', function(){
    filterUpdate();
  });

  // mobile toggle
  let toggleEl = $('.realty-filter__toggle');
  toggleEl.on('click', function(){
    toggleEl.toggleClass('active');
    let formEl = $('.realty-filter__form');

    formEl.slideToggle(400, function(){
      if(formEl.css('display') == 'none') formEl.removeAttr('style');
    });
  });

});


// update fields visibility and filter submit url
function filterUpdate(){
  // filter
  var filterEl = $('.realty-filter');

  if(!filterEl.length) return;

  // fields
  var fieldEls = getFormFields(filterEl);
    
  // values   
  var values = [];
  values['type']              = fieldEls['type'].find('select').val();                                    // type
  values['status']            = fieldEls['status'].find('select').val();                                  // status 
  values['location']          = fieldEls['location'].find('select').val();                                // location
  values['region']            = getArrayValue(fieldEls['region'].find('input:checked'));                  // region in city
  values['rural_region']      = getArrayValue(fieldEls['rural_region'].find('input:checked'));            // rural region
  values['placement']         = getArrayValue(fieldEls['placement'].find('input:checked'));               // placement type
  values['planning']          = getArrayValue(fieldEls['planning'].find('input:checked'));                // planning
  values['square_min']        = fieldEls['square'].find('[data-input="min"]').val();                      // square from
  values['square_max']        = fieldEls['square'].find('[data-input="max"]').val();                      // square to
  values['rooms_count_min']   = fieldEls['rooms_count'].find('[data-input="min"]').val();                 // rooms count from
  values['rooms_count_max']   = fieldEls['rooms_count'].find('[data-input="max"]').val();                 // rooms count to
  values['price_min']         = fieldEls['price'].find('[data-input="min"]').val();                       // price from
  values['price_max']         = fieldEls['price'].find('[data-input="max"]').val();                       // price to
  values['price_type']        = fieldEls['price_type'].find('select').val();                              // price type (for square or for object)
  values['currency']          = fieldEls['currency'].find('select').val();                                // currency


  // toggle based on realty type
  if (values['type'] == 'commercial') {
    fieldEls['placement'].show();
    fieldEls['location'].hide();
    fieldEls['rural_region'].hide();
    fieldEls['rooms_count'].hide();
    fieldEls['planning'].show();
  }
  else if (values['type'] == 'flats') {
    fieldEls['location'].show()
    fieldEls['placement'].hide();
    fieldEls['rural_region'].show();
    fieldEls['rooms_count'].show();
    fieldEls['planning'].hide();
  }
  else if(values['type'] == 'houses') {
    fieldEls['location'].show();
    fieldEls['placement'].hide();
    fieldEls['rural_region'].show();
    fieldEls['rooms_count'].show();
    fieldEls['planning'].hide();
  }

  // toggle based on house location
  if (values['location'] == 'city' || values['type'] == 'commercial') {
    fieldEls['region'].show();
    fieldEls['rural_region'].hide();
  }
  else if (values['location'] == 'rural') {
    fieldEls['region'].hide();
    fieldEls['rural_region'].show();
  }


  // form submit url
  let linkEl = document.getElementById('realty-filter-link');
  var url = '/' + (linkEl ? linkEl.value : 'search-realty');

  // type
  url += '/type-' + values['type'];

  // status
  if(values['status'] && values['status'] != 'label') url += '/status-' + values['status'];

  // location
  if(values['location'] && values['location'] != 'label' && values['type'] != 'commercial') url += '/location-' + values['location'];

  // region
  if(values['region'].length && (values['location'] == 'city' || values['type'] == 'commercial')) 
  {
    url += '/region';

    for(let i = 0; i < values['region'].length; i++) {
      url += '-' + values['region'][i];
    }
  }

  // region rural
  if(values['rural_region'].length && (values['location'] != 'city' && values['type'] != 'commercial')) 
  {
    url += '/rural_region';

    for(let i = 0; i < values['rural_region'].length; i++) {
      url += '-' + values['rural_region'][i];
    }
  }

  // placement type
  if(values['placement'].length && values['type'] == 'commercial') 
  {
    url += '/placement';

    for(let i = 0; i < values['placement'].length; i++) {
      url += '-' + values['placement'][i];
    }
  }

  // planning
  if(values['planning'].length && values['type'] == 'commercial') 
  {
    url += '/planning';

    for(let i = 0; i < values['planning'].length; i++) {
      url += '-' + values['planning'][i];
    }
  }

  // rooms count
  if(values['rooms_count_min'] && values['type'] != 'commercial') url += '/rooms_count_min-' + values['rooms_count_min'];
  if(values['rooms_count_max'] && values['type'] != 'commercial') url += '/rooms_count_max-' + values['rooms_count_max'];

  // square
  if(values['square_min']) url += '/square_min-' + values['square_min'];
  if(values['square_max']) url += '/square_max-'   + values['square_max'];

  // price
  if(values['price_min']) url += '/price_min-' + values['price_min'];
  if(values['price_max']) url += '/price_max-'   + values['price_max'];

  // price type
  url += '/price_type-' + values['price_type'];

  // currency
  url += '/currency-' + values['currency'];
 
  // add '/' to end of url
  url += '/';

  // set url to submit
  filterEl.find('[data-submit]').attr('href', url);
}

/* Filter END */